// useOverrideFields.js

import { useEffect, useMemo, useState } from 'react';

import { normalizeEnumOptions } from 'utilities/EnumOptions';

const serializeOptions = (options) => {
  if (!Array.isArray(options)) return '';
  return normalizeEnumOptions(options)
    .map((opt) => `${opt.value}:${opt.color || ''}:${opt.iconKey || ''}`)
    .join(',');
};

const buildKey = (fields) => fields
  .map((field) => {
    const name = field?.name || '';
    const group = field?.group || '';
    const label = field?.label || '';
    const type = field?.type || '';
    const targetType = field?.targetType || '';
    const fallbackDefault = field?.default;
    const defaultValue = fallbackDefault == null ? '' : String(fallbackDefault);
    const options = serializeOptions(field?.options);
    return `${name}:${group}:${label}:${type}:${targetType}:${defaultValue}:${options}`;
  })
  .join('|');

export default function useOverrideFields({ nodeTypeKey, typeDef }) {
  const [overrideFields, setOverrideFields] = useState(null);

  const typeFieldKey = useMemo(() => {
    const schemaFields = Array.isArray(typeDef?.schema?.fields)
      ? typeDef.schema.fields
      : [];
    return buildKey(schemaFields);
  }, [typeDef]);

  useEffect(() => {
    setOverrideFields(null);
  }, [nodeTypeKey]);

  useEffect(() => {
    if (!overrideFields || !typeFieldKey) return;
    const overrideKey = buildKey(overrideFields);
    if (overrideKey === typeFieldKey) {
      setOverrideFields(null);
    }
  }, [overrideFields, typeFieldKey]);

  return { overrideFields, setOverrideFields };
}
